if (!customElements.get('home-faq')) {
  customElements.define(
    'home-faq',
    class HomeFaq extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.allowMultiple = this.dataset.allowMultiple === 'true';
        this.items = Array.from(this.querySelectorAll('[data-home-faq-item]'));

        this.items.forEach((item) => {
          item.addEventListener('toggle', () => {
            if (!item.open || this.allowMultiple) return;

            this.items.forEach((otherItem) => {
              if (otherItem !== item) otherItem.open = false;
            });
          });
        });
      }
    }
  );
}
